const PAYMENT_METHOD = {
    Cash: 1,
    HealthConnect:2,
    MediClinic:3,
    CreditCard:4
  }

  export default PAYMENT_METHOD